import { render, staticRenderFns } from "./UnilavTable.vue?vue&type=template&id=a3291df2&"
import script from "./UnilavTable.vue?vue&type=script&lang=js&"
export * from "./UnilavTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports